<template>
    <Wrapper>
        <a id="main-content" class="fixed top-0" tabindex="-1"></a>

        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1">
                    {{ model.name }}
                </h1>
            </div>
        </div>

        <div class="grid grid-cols-12 base-responsive-gap mt-8 lg:mt-12">
            <div class="col-span-12 lg:col-span-8 lg:col-start-2">
                <EditableContentComponentGroup :components="model.components" has-parent-container />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import EditableContentComponentGroup from '@/components/Generic/EditableContentComponentGroup.vue';

export default {
    name: 'Release',
    components: {
        Wrapper,
        EditableContentComponentGroup,
    },
    async asyncData({ $axios, params, redirect, localePath, i18n }) {
        if (i18n.locale === 'en') {
            return await redirect(307, localePath('magazine'));
        }

        let model = null;

        await $axios
            .$get(`/presses/by-slug/${params.release}`)
            .then((res) => {
                model = res;
            })
            .catch((err) => {
                console.log(err);
            });

        if (!model) {
            return await redirect(307, localePath('press'));
        }

        await i18n.generateLocalizedRouteParams(model.locale_variants, 'release');

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('press.title'), 'press']);
        breadcrumbItems.push([model.name, 'release']);

        return {
            breadcrumbItems,
            model,
        };
    },
    head() {
        return {
            title: this.$getPageTitle(this.model.metadata),
            meta: this.$getPageMetaData(this.model.metadata),
        };
    },
};
</script>

<style scoped></style>
